import styled from "styled-components";

export default styled.div`

&{
  display: flex;
  flex-direction: column;
}
.holder{
  display: flex;
  position: relative;
  flex-direction: column;
  border-radius: 8px;
  width: max-content;
  max-width: 52%;
  margin: 5px 20px 5px 20px;
  padding: 0px 25px 15px 5px;
  text-align: center;
}


#documentData{
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 5px 2px 5px 2px;
  padding: 2px 5px 2px 0px;
  border-radius: 8px;
  justify-content: space-between;
  background-color:  ${props => props.theme.colors.background_primary};
  color: ${props => props.theme.colors.white};
  text-decoration: none;
  cursor: pointer;
  gap: 15px;

  svg{
    flex-grow: 0;
    flex-shrink: 0;
    width: 60px;
    height: 60px;
  }
  p{
    flex-grow: 1;
    flex-shrink: 1;
    word-break: break-all;
  }
}
#message-timestamp{
  position: absolute;
  margin: 0;
  right: 5px;
  bottom: 4px;
  font-size: 0.85em;
  color: ${props => props.theme.colors.primary_light};
}

.progress{
  margin-bottom: 5px;
}

.left{
  background: ${props => props.theme.colors.primary};
  text-align: left;
  padding-right: 15px;
}

.right{
  justify-self: flex-end;
  text-align: left;
  align-self: flex-end;
  background: ${props => props.theme.colors.primary};
  background: 10px solid white;
}

.left:before {
  content: "";
  width: 0px;
  height: 0px;
  position: absolute;
  border-left: 10px solid transparent;
  border-right: 10px solid ${props => props.theme.colors.primary};
  border-top: 10px solid ${props => props.theme.colors.primary};
  border-bottom: 10px solid transparent;
  left: -19px;
  top: 6px;
}
.right:before {
  content: "";
  width: 0px;
  height: 0px;
  position: absolute;
  border-left: 10px solid ${props => props.theme.colors.primary};
  border-right: 10px solid transparent;
  border-top: 10px solid ${props => props.theme.colors.primary};
  border-bottom: 10px solid transparent;
  right: -20px;
  top: 6px;
}

.sending{
  filter: brightness(70%);
}
`